@use '~/theme/theme' as *;

$row-gap: spacing(2);
$fourth-basis: calc((100% - 3 * #{$row-gap}) / 4);

.inlineSearchFilter,
.dateRangeFilter,
.documentTypeFilter,
.amountFilter,
.paymentStatusFilter,
.paymentMethodFilter,
.counterpartFilter {
  min-width: 150px;
  max-width: $fourth-basis;
  flex: 1 1 $fourth-basis;
}

.searchField {
  flex-grow: 1;
}

.filtersRow {
  gap: $row-gap;
}

.primaryFiltersRow {
  justify-content: space-between;

  .inlineSearchFilter {
    flex: 1;
    max-width: none;
  }
}

.filters {
  padding-left: 1px;
  padding-right: 1px;
}
